import { render, staticRenderFns } from "./_DecisionStepper.vue?vue&type=template&id=2608d486&scoped=true"
import script from "./_DecisionStepper.vue?vue&type=script&lang=js"
export * from "./_DecisionStepper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2608d486",
  null
  
)

export default component.exports